import { disableScroll, enableScroll} from '../utils/scroll';

let scrollPosition = 0;

export const showMenu = (navbarToggler, header) => {
  scrollPosition = window.scrollY;
  navbarToggler.classList.add('menu-open');
  header.classList.add('show');
  header.style.transform = `translateY(${scrollPosition}px)`;
  disableScroll(scrollPosition);
}

export const hideMenu = (navbarToggler, header) => {
  navbarToggler.classList.remove('menu-open');
  header.classList.remove('show');
  header.style.transform = 'translateY(0px)';
  enableScroll(scrollPosition);
}

export const toggleMobileMenu = (navbarToggler, header) => {
  if(!navbarToggler) return;
  navbarToggler.addEventListener('click', () => (!navbarToggler.classList.contains('menu-open')) ? showMenu(navbarToggler, header) : hideMenu(navbarToggler, header));
  document.addEventListener("keyup", (e) => (e.key === 'Escape' && document.body.classList.contains('disable-scroll')) && hideMenu(navbarToggler, header));
}

const changeMenuLinePosition = (targetLeft, navMainMenu) => {
  if (window.innerWidth >= 1025) {
    const left = targetLeft - navMainMenu.getBoundingClientRect().left;
    navMainMenu.style.setProperty("--magic-line", `${left}px`);
    navMainMenu.style.setProperty("--width", `50px`);
  }
};

export const megicLine = (navMainMenu) => {
  let currentMenuItem = navMainMenu.querySelector('.current-menu-item');

  const updateLinePosition = () => {
    if (currentMenuItem) {
      const targetLeft = currentMenuItem.getBoundingClientRect().left;
      changeMenuLinePosition(targetLeft, navMainMenu);
    } else {
      navMainMenu.style.setProperty("--magic-line", `0px`);
      navMainMenu.style.setProperty("--width", `0px`);
    }
  };

  if (currentMenuItem) {
    changeMenuLinePosition(currentMenuItem.getBoundingClientRect().left, navMainMenu);
  } else {
    navMainMenu.classList.add('nav-main__menu--empty');
    navMainMenu.style.setProperty("--width", `0px`);
  }

  navMainMenu.addEventListener('mousemove', (e) => {
    if (e.target.closest('.menu-item')) {
      const targetLeft = e.target.getBoundingClientRect().left;
      changeMenuLinePosition(targetLeft, navMainMenu);
    }
  });

  navMainMenu.addEventListener('mouseout', (e) => {
    if (!navMainMenu.contains(e.relatedTarget)) {
      updateLinePosition();
    }
  });

  window.addEventListener('resize', updateLinePosition);
};
